import { useTranslations } from '@vocab/react';
import { Badge, Box, Text, Inline } from 'braid-design-system';
import { observer } from 'mobx-react';
import type React from 'react';

import { BUCKETS } from 'src/stores/JobApplicationStore/types';
import useBucketLabel from 'src/utils/hooks/useBucketLabel';

import translations from './.vocab';

import * as styles from './StatusFolderButton.css';

export interface StatusFolderButtonProps {
  onClick: () => void;
  count: number;
  newCount?: number;
  isSelected: boolean;
  type: BUCKETS;
}
export const StatusFolderButton: React.FC<StatusFolderButtonProps> = observer(
  ({ onClick, count, newCount, isSelected, type }) => {
    const { t } = useTranslations(translations);
    const { getLabelFromBucket } = useBucketLabel();

    return (
      <>
        <Box
          key={type}
          component="button"
          data-testid="desktop-buckets"
          onClick={() => {
            onClick();
          }}
          className={styles.filterStatusButton}
        >
          <Box
            className={[styles.statusFolderButton]}
            justifyContent="spaceBetween"
            data-testid="item"
            background={isSelected ? 'formAccentSoft' : undefined}
          >
            <Inline space="small" alignY="center">
              <Text weight={isSelected ? 'strong' : 'regular'} size="small">
                <>{getLabelFromBucket(type)}</>
              </Text>
              {newCount !== undefined && newCount > 0 ? (
                <Badge bleedY tone="positive">{`${t('newCount New', {
                  newCount,
                })}`}</Badge>
              ) : null}
            </Inline>

            <Box
              className={`${
                styles.badgeState[isSelected ? 'active' : 'inactive']
              } ${styles.badge}`}
              aria-label={t('count applications', { count })}
            >
              <Text
                size="xsmall"
                weight="strong"
                tone="neutral"
                data={
                  type === BUCKETS.NOT_SUITABLE
                    ? {
                        intercomid: 'Not Suitable',
                      }
                    : {}
                }
              >
                {t('count', { count })}
              </Text>
            </Box>
          </Box>
        </Box>
      </>
    );
  },
);
